/* @flow */
import React from 'react';

import { Tooltip } from 'components/UIKit/Tooltip';
import THead from 'components/UIKit/Table/THead';
import Tr from 'components/UIKit/Table/Tr';
import Th from 'components/UIKit/Table/Th';
import { HelpIcon } from 'components/icons';

export default function ProjectsColumns(): React.Element {
  return (
    <THead>
      <Tr>
        <Th>ID</Th>
        <Th style={{ width: `14rem` }}>Name</Th>
        <Th>Primary Site</Th>
        <Th>Submission State</Th>
        <Th>
          Batch Release
          <span style={{ marginLeft: '0.6rem' }}>
            <Tooltip
              Component={
                <span>
                  To release project data currently found in the Pre-Release
                  Data Review Portal, click "Request Release". If release has
                  already been requested, please wait for data release to be
                  completed by the GDC team.
                </span>
              }
            >
              <span>
                <HelpIcon style={{ fontSize: '1.3rem', color: '#2a72a5' }} />
              </span>
            </Tooltip>
          </span>
        </Th>
        <Th>
          Release State
          <span style={{ marginLeft: '0.6rem' }}>
            <Tooltip
              Component={
                <span>
                  Once a project is <b>Released</b> all submitted metadata and
                  data can be released to authorized users by the GDC. The
                  release of harmonized data will occur once processing is
                  complete.
                </span>
              }
            >
              <span>
                <HelpIcon style={{ fontSize: '1.3rem', color: '#2a72a5' }} />
              </span>
            </Tooltip>
          </span>
        </Th>
        <Th>Last Updated</Th>
      </Tr>
    </THead>
  );
}
